import { render, staticRenderFns } from "./ArticleCardTable.vue?vue&type=template&id=4f947e51&scoped=true"
import script from "./ArticleCardTable.vue?vue&type=script&lang=js"
export * from "./ArticleCardTable.vue?vue&type=script&lang=js"
import style0 from "./ArticleCardTable.vue?vue&type=style&index=0&id=4f947e51&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f947e51",
  null
  
)

export default component.exports